import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

interface Props {
  image: string
  title: string
  description: ReactNode
  button: string
  content?: ReactNode
  additionalButton?: string
  buttonDisabled?: boolean
  buttonLoading?: boolean
  onClick: () => void
  onClickAdditional?: () => void
}

export const AutoRefundDialog: FC<Props> = ({
  image,
  title,
  description,
  button,
  content,
  additionalButton,
  buttonDisabled,
  buttonLoading,
  onClick,
  onClickAdditional,
}) => {
  return (
    <div className={styles.dialog}>
      <img
        className={styles.icon}
        src={image}
        alt=""
      />

      <p className={clsx('bold-20', styles.title)}>{title}</p>
      <div className={clsx('regular-14', styles.description)}>
        {description}
      </div>

      {content && <div className={styles.content}>{content}</div>}

      <div className={styles.actions}>
        <Button
          className={styles.button}
          disabled={buttonDisabled}
          loading={buttonLoading}
          onClick={onClick}
        >
          <span className="semi-bold-17">{button}</span>
        </Button>

        {additionalButton && onClickAdditional && (
          <Button
            className={styles.button}
            variant="transparentBlue"
            onClick={onClickAdditional}
          >
            <span className="semi-bold-17">{additionalButton}</span>
          </Button>
        )}
      </div>
    </div>
  )
}
